import { requireOptionalNativeModule } from 'expo-modules-core';

/** What the Messages and Siri extensions render for the device holder's link. */
export type SharedLinkContent = {
  url: string;
  title: string;
  resultDialog: string;
};

type PrimumSharedLinkNative = {
  setSharedLinkContent(content: SharedLinkContent | null): boolean;
};

const nativeModule = requireOptionalNativeModule<PrimumSharedLinkNative>('PrimumSharedLink');

/**
 * Writes the device holder's link and its labels into the iOS app group read by the Messages
 * and App Intents extensions, or clears all of it with `null`. A no-op where the module is
 * absent: Android, web, and any binary built before the module shipped.
 *
 * @returns whether the value reached the app group.
 */
export function setSharedLinkContent(content: SharedLinkContent | null): boolean {
  return nativeModule?.setSharedLinkContent(content) ?? false;
}
